import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { GlobalService } from './global.service';
import { LogAcesso } from '../models/log-acesso';

@Injectable({
  providedIn: 'root',
})
export class LogAcessoService {
  constructor(private globalService: GlobalService, private http: HttpClient) {}

  InserirAcessoTela() {
    return this.http.get<any>(
      globals.apiUrl + '/api/LogAcesso/InserirAcessoTela'
    );
  }

  Salvar(logAcesso: LogAcesso) {
    return this.http.post<LogAcesso>(
      globals.apiUrl + '/api/LogAcesso/Salvar',
      logAcesso
    );
  }
}
